import React, { Component } from "react";
import Autosuggest from "react-autosuggest";
import lodash from "lodash"; // library added for debounce functionality

// services
// import FleetManagerService from "../../services/FleetManagerService";
import UserService from "../../services/UserService";
import StorageService from "../../services/Storage";

import "./AutoSuggestionDealer.css";

class AutoSuggestionDealer extends Component {
  constructor() {
    super();

    this.state = {
      value: "",
      suggestions: [],
      zone: "all",
      year: null,
    };
    this.searchReport = lodash.debounce(this.searchReport, 500);
  }

  componentWillReceiveProps(props) {
    if (props.zone) {
      this.setState({
        zone: props.zone,
      });
    }
    if (props && props.controls && props.controls.year) {
      this.setState({
        year: props.controls.year.value,
      });
    }
  }

  getAllDealerReport = (page, search) => {
    UserService.searchFleet(search)
      .then((data) => {
        const { data: fleets } = data.data;
        const suggestions = fleets;
        this.setState({ suggestions });
      })
      .catch((e) => { });
    // FleetManagerService.getOfftakeScorecardFleet(page, 10000000, search)
    //   .then(data => {
    //     const { fleets } = data.data.data;
    //     const suggestions = fleets;
    //     this.setState({ suggestions });
    //   })
    //   .catch(e => {
    //     console.error("e", e);
    //   })
  };

  openViewReportPage = (sapId, name, member_id, type) => {
    StorageService.removeSelectedFmData();
    if (this.props.getSelectedFleetData && !this.props.HoDashboard) {
      this.props.getSelectedFleetData(sapId, name, member_id, this.state.zone, type);
    } else {
      this.props.history.push(
        `/?id=${sapId}&name=${name}&memId=${member_id}&zone=${this.state.zone
        }&HOD=${this.props && this.props.HOD}&y=${this.state.year ? this.state.year : new Date().getFullYear()
        }&cfd=${null}&member_type=${type}`
      );
    }
  };

  searchReport = (search) => {
    this.getAllDealerReport(1, search.value, true);
  };

  getSuggestionValue = (suggestion) => {
    this.openViewReportPage(
      suggestion.uuid,
      suggestion.business_name,
      suggestion.member_id,
      suggestion.type
    );
    return suggestion.member_id;
  };

  renderSuggestion = (suggestion) => {
    return (
      <span>
        {suggestion.business_name} ({suggestion.member_id})
      </span>
    );
  };

  onChange = (event, { newValue, method }) => {
    this.setState({
      value: newValue,
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  render() {
    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: "Search using fleet name and member id",
      value,
      onChange: this.onChange,
    };

    return (
      <div>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.searchReport}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
        />
        <img src="images/search.svg" className="report-search" alt="search"></img>
      </div>
    );
  }
}

export default AutoSuggestionDealer;
